import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_to_irb_export_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    export_type: fromDatatype.VarcharDatatypeInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.NumericDatatypeInterface;
    export_format: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    error_message: fromDatatype.TextDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_to_irb_export_file_hdr_RowClass implements bl_fi_my_einvoice_to_irb_export_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    export_type: fromDatatype.VarcharDatatypeInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.NumericDatatypeInterface;
    export_format: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    error_message: fromDatatype.TextDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}